// This file is auto-generated by scripts/generate-module-registry.js
// Do not edit manually - it will be overwritten
// Client-safe: no moduleRegistry/getModuleImport (see generated-module-registry-loader.ts for server).

type PackageApp = { id: string; name: string; description: string; icon: string; package: string; type: string; source: string; [key: string]: unknown }
type SystemApp = { id: string; name: string; icon: string; link: string; visibility: string; category: string; order: number }

/** Module IDs available in this deployment. Client-safe. */
export const availableModules = ['shell', 'chat', 'workspace', 'rag', 'mentor'] as const;

export type ModuleName = (typeof availableModules)[number];

export const getAvailableModules = (): string[] => {
  return [...availableModules];
};

/** Modules that expose app UI (korvo.exposesApp !== false in package.json). Use for app home, sidebar. */
export const getAppModules = (): string[] => {
  return ['shell', 'chat'];
};

export const isModuleEnabled = (moduleName: string): boolean => {
  return availableModules.map(m => m.toLowerCase()).includes(moduleName.toLowerCase());
};

/** Package apps declared in korvo-routes.json apps arrays. Discovered at codegen time. */
export const packageApps: PackageApp[] = [] as PackageApp[];

/** System apps collected from packages that export system-apps.ts. */
import { coreSystemApps } from '@korvo/core/system-apps'
import { shellSystemApps } from '@korvo/shell/system-apps'

export const systemApps: SystemApp[] = [

  ...coreSystemApps,
  ...shellSystemApps,
]
